import { Box } from "@chakra-ui/react";
import Toast from "./Toast";
import { ToastItem } from "@/src/hooks/useToast";

interface ToastContainerProps {
  toasts: ToastItem[];
  hideToast: (id: string) => void;
}

function ToastContainer({ toasts, hideToast }: ToastContainerProps) {

  return (
    <Box
      position="fixed"
      top="20px"
      left="20px"
      zIndex={2000}
      pointerEvents="none"
    >
      {toasts.map((toast, index) => (
        <Box
          key={toast.id}
          mb={3}
          style={{
            pointerEvents: 'auto'
          }}
        >
          <Toast
            type={toast.type}
            title={toast.title}
            message={toast.message}
            duration={toast.duration}
            isVisible={toast.isVisible}
            onClose={() => hideToast(toast.id)}
          />
        </Box>
      ))}
    </Box>
  );
}

export default ToastContainer; 